import { render, staticRenderFns } from "./ModalInfoAcordo.vue?vue&type=template&id=72367f9a"
import script from "./ModalInfoAcordo.vue?vue&type=script&lang=js"
export * from "./ModalInfoAcordo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports